import React from "react";

export default function ProcedureBotAvailabilityField({ checked, onChange, disabled = false }) {
  return (
    <label className="flex cursor-pointer items-start gap-3 rounded-lg border border-blue-100 bg-blue-50 p-3 text-sm hover:bg-blue-100/60">
      <input
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        disabled={disabled}
        className="mt-0.5 h-4 w-4 shrink-0 accent-blue-600"
      />
      <span>
        <strong>Disponibilizar no bot de orientações</strong>
        <span className="block text-gray-600">Clientes poderão consultar este vídeo e recebê-lo automaticamente pelo WhatsApp.</span>
      </span>
    </label>
  );
}
